// #### Recipes ####
const CommunicationEventRecipe = {
    $type$: 'Recipe',
    name: 'CommunicationEvent',
    rule: [
        {
            itemprop: 'timestamp',
            itemtype: { type: 'number' }
        },
        {
            itemprop: 'channelType',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'endpointRef',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['*']) },
            optional: true
        },
        {
            itemprop: 'assemblyRef',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['*']) },
            optional: true
        },
        {
            itemprop: 'direction',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'notes',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'source',
            itemtype: { type: 'string' }
        }
    ]
};
export default CommunicationEventRecipe;
//# sourceMappingURL=CommunicationEvent-1-0-0.js.map